import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Scissors } from "lucide-react";
import { Logo } from "@/components/Logo";

const NAV = [
  { label: "Ecommerce Tools", path: "/ecommerce-tools" },
  { label: "AI Listing Tools", path: "/ai-tools" },
  { label: "Guides", path: "/blog" },
  { label: "All Free Tools", path: "/#all-tools" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/90 border-b border-slate-200/80 shadow-sm" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-testid="header-home-link" className="shrink-0">
            <Logo />
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => (
              <Link
                key={n.path}
                to={n.path}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
                  pathname === n.path ? "text-blue-700 bg-blue-50" : "text-slate-600 hover:text-blue-700 hover:bg-slate-50"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:block">
            <Link
              to="/tools/meesho-shipping-label-crop"
              data-testid="header-cta"
              className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2.5 rounded-xl text-sm font-semibold shadow-lg shadow-blue-500/25 transition-colors"
            >
              <Scissors className="w-4 h-4" /> Free Label Cropper
            </Link>
          </div>

          <button
            className="md:hidden p-2 rounded-lg text-slate-700 hover:bg-slate-100"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-3 space-y-1" data-testid="mobile-menu">
          {NAV.map((n) => (
            <Link
              key={n.path}
              to={n.path}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="block px-3 py-3 rounded-lg text-base font-semibold text-slate-700 hover:bg-slate-50"
            >
              {n.label}
            </Link>
          ))}
          <Link
            to="/tools/meesho-shipping-label-crop"
            onClick={() => setOpen(false)}
            data-testid="mobile-header-cta"
            className="block text-center bg-blue-600 text-white px-4 py-3 rounded-xl font-semibold mt-2"
          >
            Free Label Cropper
          </Link>
        </div>
      )}
    </header>
  );
}
